import { i18nNamespaceMap, tolgeeStaticData } from '@controls/config/translation/namespace-map';
import { DevTools, FormatSimple, Tolgee } from '@tolgee/react';
import { I18nextPlugin } from '@tolgee/i18next';
import { InContextTools } from '@tolgee/web/tools';
import { getPublicEnv } from '@UI/components/PublicEnv/public-env';
import { defaultLanguage, defaultNs } from './constants/default';

export * from '@controls/config/translation/namespace-map';
export * from './hooks/useTolgeeTranslation';
export * from './provider';

export const ALL_LANGUAGES = ['en', 'fr'];
export const LANGUAGE_COOKIE = 'trustedo-language-locale';
export const enableTolgeeInContextMode = getPublicEnv('TOLGEE_ENABLED') === 'true';

export const tolgee = Tolgee()
  .use(DevTools())
  .use(InContextTools())
  .use(FormatSimple())
  // .use(
  //   BackendFetch({
  //     prefix: './assets/translated',
  //     // getPath: ({ language = defaultLanguage, namespace, prefix }) => {
  //     //   return `${prefix}/${namespace}/${language}.json`;
  //     // },
  //     getData: (r) => {
  //       return r.json();
  //     },
  //     timeout: 3_000,
  //     fallbackOnFail: true,
  //   }),
  // )
  .use(I18nextPlugin())
  .init({
    apiUrl: enableTolgeeInContextMode ? getPublicEnv('TOLGEE_API_URL') : '',
    apiKey: enableTolgeeInContextMode ? getPublicEnv('TOLGEE_API_KEY') : '',
    defaultLanguage: defaultLanguage,
    defaultNs: defaultNs,
    fallbackLanguage: defaultLanguage,
    fallbackNs: defaultNs,
    ns: i18nNamespaceMap as string[],
    availableNs: i18nNamespaceMap as string[],
    staticData: tolgeeStaticData,
    autoLoadRequiredData: true,
  });
